import Vue from "vue";
import Router from "vue-router";
import logistics from "@/view/Layout/index.vue";
import TimeOutIndex from "@/view/timeOut/index.vue";
import liveComponent from "@/view/live/index.vue";
import popAllComponent from "@/view/popAll/index.vue";
import holidayComponent from "@/view/holiday/index.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "logistics",
            component: logistics,
        },
        {
            path: "/TimeOutIndex",
            name: "TimeOutIndex",
            component: TimeOutIndex,
        },
        {
            path: "/tianXu",
            name: "liveComponent",
            component: liveComponent,
        },
        {
            path: "/Savanna",
            name: "popAllComponent",
            component: popAllComponent,
        },
        {
            path: "/FangJia",
            name: "holidayComponent",
            component: holidayComponent,
        },
    ],
});
